export class Token {
    accessToken: string;
    expireOn: Date;
    passwordExpireOn: Date;
}
